import { useAuth0 } from "@auth0/auth0-react";
import React, {
  createContext,
  FC,
  ReactNode,
  useEffect,
  useMemo,
  useState,
} from "react";
import { decodeToken } from "react-jwt";
import { appConfig } from "env-config";

export interface IAuth {
  role?: string;
  isSchedulling?: boolean;
  token?: string;
  companies?: Array<number>;
  setLoading?: (state: boolean) => void;
}
interface Auth0ProviderProps {
  children: ReactNode;
}

const AuthProvider = ({ children }: Auth0ProviderProps) => {
  const [token, setToken] = useState<string>();

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);
  const domain = appConfig.REACT_APP_AUTH0_DOMAIN;
  const clientId = appConfig.REACT_APP_AUTH0_CLIENT_ID;
  const audience = appConfig.REACT_APP_AUTH0_AUDIENCE;
  const { isAuthenticated, loginWithRedirect, isLoading, user, logout } =
    useAuth0();
  useEffect(() => {
    (async function login() {
      setLoading(true);

      if (!isLoading && !user) {
        setLoading(false);
        await loginWithRedirect();
      } else {
        setLoading(false);
      }
    })();
  }, [isLoading]);

  const role = useMemo<string>(() => {
    const userInfos = JSON.parse(
      localStorage.getItem(
        `@@auth0spajs@@::${clientId}::${audience}::openid profile email offline_access`
      )
    );
    setToken(userInfos?.body.access_token);
    if (userInfos) {
      setLoading(false);
      const tokenData: any = decodeToken(userInfos?.body.access_token);
      return tokenData.role;
    }
    return null;
  }, [isLoading, user]);

  // const isSchedulling = useMemo<boolean>(() => {
  //   if (token) {
  //     const tokenData: any = decodeToken(token);
  //     return tokenData?.hasSchedulingAccess === "True";
  //   }
  //   return false;
  // }, [token]);

  // const companies = useMemo<Array<number>>(() => {
  //   const userInfos = JSON.parse(
  //     localStorage.getItem(
  //       `@@auth0spajs@@::${clientId}::${audience}::openid profile email offline_access`
  //     ) ?? "{}"
  //   );
  //   const token = userInfos?.body?.access_token;

  //   if (!token) {
  //     return [];
  //   }
  //   setLoading(false);

  //   const tokenData: any = decodeToken(token);
  //   return tokenData.companies
  //     ? tokenData.companies.split(",").map(Number)
  //     : [];
  // }, [isLoading, user]);

  // const authorize = useCallback(async () => {
  //   const token = Cookies.get('SCLToken')
  //   if (!token) {
  //     localStorage.setItem('userSSO', userData.id_token)

  //     try {
  //       const {
  //         data: { data }
  //       } = await auth.session(userData.id_token)

  //       setToken(data.token)

  //       Cookies.set('SCLToken', data.token)
  //       Cookies.set('SCLRefreshToken', data.refreshToken)
  //     } catch (ex) {
  //       setError(true)
  //     }

  //     setLoading(false)
  //   } else {
  //     localStorage.setItem('userSSO', userData.id_token)
  //     setToken(token)
  //     setLoading(false)
  //   }
  // }, [userData])

  return (
    <AuthContext.Provider value={{ token }}>
      {loading ? (
        <div>Aguarde enquanto atualizamos suas credenciais...</div>
      ) : error ? (
        <div>Error</div>
      ) : (
        children
      )}
    </AuthContext.Provider>
  );
};

export default AuthProvider;
export const AuthContext = createContext<IAuth>({} as IAuth);
